import { MarkType } from 'prosemirror-model';
import { objectIncludes } from './object.js';
export function getMarksBetween(from, to, node) {
    const marks = [];
    node.nodesBetween(from, to, (node, pos) => {
        marks.push(...node.marks.map((mark) => ({
            mark,
            from: pos,
            to: pos + node.nodeSize,
        })));
    });
    return marks;
}
export function getMarkRange($pos, type, attributes = {}) {
    if (!$pos || !type) {
        return;
    }
    const start = $pos.parent.childAfter($pos.parentOffset);
    if (!start.node) {
        return;
    }
    const mark = findMarkInSet(start.node.marks, type, attributes);
    if (!mark) {
        return;
    }
    let startIndex = $pos.index();
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    // findMarkInSet(start.node.marks, type, attributes);
    while (startIndex > 0 &&
        mark.isInSet($pos.parent.child(startIndex - 1).marks)) {
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while (endIndex < $pos.parent.childCount &&
        isMarkInSet($pos.parent.child(endIndex).marks, type, attributes)) {
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        mark,
        from: startPos,
        to: endPos,
    };
}
function findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item) => item.type === type && objectIncludes(item.attrs, attributes));
}
function isMarkInSet(marks, type, attributes = {}) {
    return !!findMarkInSet(marks, type, attributes);
}
export function getMarkType(m, schema) {
    if (m instanceof MarkType) {
        return m;
    }
    const name = typeof m === 'string' ? m : m.name;
    return schema.marks[name];
}
//# sourceMappingURL=mark.js.map